import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { t } from "i18next";
import { startLogout } from "./authActions";
import { debugLogActions } from "../helpers/debugHelper";

export const startRegisterSearchInfo = (searchInfo) => {
  
  return async (dispatch, getState) => {
    const state = getState();
    const { searchInfosRegisterEnabled } = state.configuration;

    if (searchInfosRegisterEnabled === "true") {
      
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_SEARCH_INFO}`,
        "add",
        searchInfo,
        "POST"
      );

      const body = await resp.json();

       debugLogActions(':: searchInfoActions, startRegisterSearchInfo', { 'body': body });

      if (body.ok) {
        dispatch(registerSearchInfo(body.searchInfo));
      } else {
        if (body.code === "bak-error-001") {
           Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
          
        }
        if (body.code === "bak-aut-tok-inv-001") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-001"), "error");
          dispatch(startLogout());
        }
        if (body.code === "bak-aut-tok-inv-002") {
          Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
          dispatch(startLogout());
        }
      }
    } else {

    }
  };
};

const registerSearchInfo = (searchInfo) => ({
  type: types.SEARCH_INFO_START_REGISTER,
  payload: searchInfo,
});

/** Verificar */
export const cleanSearchText = () => ({
  type: types.SEARCH_INFO_CLEAN_SEARCH_TEXT,
});

export const setSearchText = (searchText) => ({
  type: types.SEARCH_INFO_SET_SEARCH_TEXT,
  payload: searchText,
});